import type { SelectChangeEvent } from '@mui/material/Select'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import EllipsisTypography from '@/components/dataDisplay/EllipsisTypography'
import CustomSelectField from '@/components/inputs/CustomSelectField'
import { FIELD_WIDTH } from '@/constants/layout'
import { useSitesQuery } from '@/features/site/hooks/useSitesQuery'
import { getSiteOptions } from '@/features/site/utils/getSiteOptions'
import { sortOptionsAlphabetically } from '@/utils/sortOptionsAlphabetically'

export function SiteSelector({ siteUuid }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [selectedSite, setSelectedSite] = useState<string | undefined>('')
  const { sites } = useSitesQuery()

  const options = (sites?.length ?? 0) > 0 ? sortOptionsAlphabetically<string>(getSiteOptions(sites!)) : []

  useEffect(() => {
    if ((sites?.length ?? 0) > 0) {
      setSelectedSite(siteUuid)
    }
  }, [sites])

  function changeSite(evt: SelectChangeEvent) {
    const newSiteUuid = evt.target.value
    const newPath = pathname.replace(siteUuid, newSiteUuid)

    navigate(newPath)
  }

  return (
    <CustomSelectField
      autoWidth
      id="sites"
      label={t('customer_details.customer_selector')}
      options={options}
      renderValue={(value) => {
        const site = sites?.find((site) => site.uuid === value)

        if (!site) {
          return null
        }

        return <EllipsisTypography tooltipTitle={site.name}>{site.name}</EllipsisTypography>
      }}
      size="medium"
      sx={{ maxWidth: FIELD_WIDTH }}
      value={selectedSite}
      variant="outlinedWhite"
      onChange={changeSite}
    />
  )
}
